import Update from "../../table/Update";
import { useState,useEffect } from "react";
import ApiService from "../../../services/apiService";

import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { updateChacks,chackTitle } from "../../../constants";
import { useNavigate } from "react-router-dom";
const UpdateChack = () => {
    const {Id} = useParams();
    const [data,setData] = useState<any>(null);
    const [distributaryData,setDistributaryData] = useState<any>(null);
    const [schemeVillageData,setSchemeVillageData] = useState<any>(null);
    const [wuaData,setWuaData] = useState<any>([])

    const navigate = useNavigate();

    const initialData = {
        ChackName:data?.chackName,
        ChackArea:data?.chackArea,
        ChackLeader:data?.chackLeader,
        ChackLeader_MobileNumber:data?.chackLeader_MobileNumber,  
        Long:data?.long,
        Lat:data?.lat,
        Duid:data?.duid,
        Duty:data?.duty,
        PCFRV_ScadaControl:data?.pcfrV_ScadaControl,
        no_Of_ON_OF_Valves:data?.no_Of_ON_OF_Valves,
        Scheme_Village:data?.scheme_Village,
        Distributary_Zone:data?.distributary_Zone,
        HeadQuaterName:data?.headQuaterName
    }
    useEffect(()=>{
        const distributaryData = async ( )=>{
            try{
                  const response = await ApiService.axiosApi(`/dzone`,{
                    method:"GET",
                    params:{
                      pageNumber :0,
                      pageSize:0
                 }
                  })
                  if(response.success){
                    setDistributaryData(response.data.data);
                  }
              }catch(error:any){
                toast.error(error.message|| "Failed to fetch Distributary Data");
              }
        }

        const fecthWua = async()=>{
          try{
              const response = await ApiService.axiosApi(`/wua`,{
                  method:'GET'
              });
              if(response.success){
                  setWuaData(response.data)
              }
          }catch(error:any){
             toast.error(error.message || "Failed to fetch Scheme Village");
         }
     }
     
     fecthWua();
        distributaryData();
    },[])

    useEffect(()=>{
        const schemeVillage = async()=>{
            try{
                const response = await ApiService.axiosApi(`/schemevillage`,{
                    method:"GET",
                    params:{
                      pageNumber :0,
                      pageSize:0
                 }
                })
                if(response.success){
                    setSchemeVillageData(response.data.data);
                }
            }catch(error:any){
                toast.error(error.message|| "Failed to fetch Scheme Village");
            }
        }
        schemeVillage();
    },[])
    useEffect(()=>{
        const fetchChack = async ()=>{
            try{
                const response = await ApiService.axiosApi(`/chack/${Id}`,{
                    method:"GET"
                })
                if(response.success){
                    setData(response.data);
                }
            }catch(error:any){
                toast.error(error.message|| "Failed to fetch Chack");
            }
        }
        fetchChack();
    },[])
    
    
          
        const updateChack = async (data:any)=>{
            try{

                const response =await ApiService.axiosApi(`/chack/${Id}`,{
                    method:"PUT",
                    data:data
                })
                if(response.success){
                  navigate(-1)
                    toast.success(response.message|| "Chack Updated");
                }else{
                    toast.error(response.message|| "Failed to update Chack");
                }
            }catch(error:any){
                toast.error(error.message|| "Failed to update Chack");
            }
            
        }
    
    
    return (
        <Update title={updateChacks}
                 parentTitle ={chackTitle}
          fields={[
            {
              name: "ChackName",
              label: "Chak Name",
              type: "text"
            },
            {
              name: "ChackArea",
              label: "Chak Area",
              type: "text"
            },
            {
              name: "Duty",
              label: "Duty",
              type: "text"
            },
            {
              name: "PCFRV_ScadaControl",
              label: "PCFRV Scada Control",
              type: "text"
            },
            {
              name: "no_Of_ON_OF_Valves", 
              label: "Number of ON/OFF Valves",
              type: "text"
            },
            
           
            {
              name: "ChackLeader",
              label: "Chak Leader",
              type: "text"
            },
            {
              name: "ChackLeader_MobileNumber",
              label: "Chak Leader Mobile Number",
              type: "tel"
            },
            {
              name: "Long",
              label: "Long",
              type: "text"
            },
            {
              name: "Lat", 
              label: "Lat",
              type: "text"
            },
            {
              name: "Duid",
              label: "DUID",
              type: "text"
            },
            {
              name: 'HeadQuaterName',
              label:'Wua',
              isDropdown:true,
              dropdownData:wuaData,
              dropdownLabel:"headQuaterName",
              idFieldName:"Wua_Id"
          },
            
            {
              name: "Scheme_Village",
              label: "Scheme Village",
              isDropdown:true,
              dropdownData:schemeVillageData,
              dropdownLabel:"scheme_Village",
              idFieldName:"SchemeVillageId"
           },
           {
            name: "Distributary_Zone",
            label: "Distributary Zone", 
            isDropdown:true,
            dropdownData:distributaryData,
            dropdownLabel:"distributary_Zone",
            idFieldName:"DistributaryZoneId"
          }

            
          ]}

          onSubmit={updateChack}
          initialData={initialData} />
    )
}
export default UpdateChack;
